function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg076Philippines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "0,512 256,256 0,0  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "169.699,256 137.864,241.026 154.817,210.194 120.247,216.806 115.866,181.884    91.786,207.568 67.708,181.884 63.325,216.806 28.757,210.193 45.709,241.025 13.873,256 45.709,270.974 28.757,301.806    63.328,295.194 67.706,330.116 91.786,304.432 115.866,330.116 120.247,295.194 154.815,301.807 137.863,270.976  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "21.789,50.825 30.87,63.52 45.749,58.807 36.481,71.366 45.562,84.06 30.753,79.128    21.485,91.687 21.602,76.08 6.793,71.146 21.673,66.433  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "21.789,420.313 30.87,433.008 45.749,428.295 36.481,440.854 45.562,453.55 30.753,448.617    21.485,461.175 21.602,445.568 6.793,440.634 21.673,435.921  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "210.395,235.569 201.314,248.264 186.435,243.551 195.703,256.11 186.622,268.806    201.431,263.873 210.699,276.431 210.582,260.824 225.391,255.89 210.511,251.177  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg076Philippines);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };